// Codex paths match the vector icons in packages/brand/src/video-elements.
// VS Code codicons copyright Microsoft Corporation, licensed under CC BY 4.0.
// Seti UI React glyph copyright 2014 Jesse Weed, licensed under MIT.
const appIcons = {
	skill: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M12 2 4 6.5v11L12 22l8-4.5v-11L12 2Z M4 6.5l8 4.5 8-4.5 M12 11v11 M4 12l8 4.5 8-4.5',
				fill: false,
				opacity: 1,
			},
		],
	},
	folder: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M3.75 7.75a2 2 0 0 1 2-2H10l2 2h6.25a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5.75a2 2 0 0 1-2-2z',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M3.75 10h16.5',
				fill: false,
				opacity: 1,
			},
		],
	},
	share: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M12 15V4.5',
				fill: false,
				opacity: 1,
			},
			{
				d: 'm8.75 7.75 3.25-3.25 3.25 3.25',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M6.25 11.75v5a2.25 2.25 0 0 0 2.25 2.25h7a2.25 2.25 0 0 0 2.25-2.25v-5',
				fill: false,
				opacity: 1,
			},
		],
	},
	sliders: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M4.5 6.25h3M11 6.25h8.5',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M7.5 6.25a1.75 1.75 0 1 0 3.5 0a1.75 1.75 0 1 0 -3.5 0',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M4.5 12h8.25M16.25 12h3.25',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M12.75 12a1.75 1.75 0 1 0 3.5 0a1.75 1.75 0 1 0 -3.5 0',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M4.5 17.75H7M10.5 17.75h9',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M7 17.75a1.75 1.75 0 1 0 3.5 0a1.75 1.75 0 1 0 -3.5 0',
				fill: false,
				opacity: 1,
			},
		],
	},
	bottomPanel: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M5.25 4.5h13.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1 -2.25 2.25h-13.5a2.25 2.25 0 0 1 -2.25 -2.25v-10.5a2.25 2.25 0 0 1 2.25 -2.25z',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M3.5 15.5h17',
				fill: false,
				opacity: 1,
			},
		],
	},
	rightPanel: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M5.25 4.5h13.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1 -2.25 2.25h-13.5a2.25 2.25 0 0 1 -2.25 -2.25v-10.5a2.25 2.25 0 0 1 2.25 -2.25z',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M16 5v14',
				fill: false,
				opacity: 1,
			},
		],
	},
	chevronDown: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'm7.5 9.5 4.5 4.5 4.5-4.5',
				fill: false,
				opacity: 1,
			},
		],
	},
	handoff: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M4 12h5l7-7',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M12 5h4v4',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M9 12h2l5 5',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M12 17h4v-4',
				fill: false,
				opacity: 1,
			},
		],
	},
	spinner: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M4.25 12a7.75 7.75 0 1 0 15.5 0a7.75 7.75 0 1 0 -15.5 0',
				fill: false,
				opacity: 0.38,
			},
			{
				d: 'M12 4.25A7.75 7.75 0 0 1 19.75 12',
				fill: false,
				opacity: 1,
			},
		],
	},
	copy: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M6.5 8h7a2 2 0 0 1 2 2v7.5a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-7.5a2 2 0 0 1 2 -2z',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M8 8V6.5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-1.5',
				fill: false,
				opacity: 1,
			},
		],
	},
	feedback: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M2 8h3l3-6.5c.45-.95 1.9-.62 1.9.43V7h2.6c.8 0 1.4.76 1.18 1.53l-1.25 4.65c-.2.76-.9 1.32-1.7 1.32H5',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M2 8v7h3V8',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M22 9v7h-3V9',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M19 9h-3.9c-.8 0-1.5.55-1.7 1.32L12.3 14.5H16v5.57c0 1.05-1.45 1.38-1.9.43l-2-4.5',
				fill: false,
				opacity: 1,
			},
		],
	},
	plus: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M12 6.5v11M6.5 12h11',
				fill: false,
				opacity: 1,
			},
		],
	},
	alertCircle: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M4 12a8 8 0 1 0 16 0a8 8 0 1 0 -16 0',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M12 7.75v5.5',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M11.2 16.25a0.8 0.8 0 1 0 1.6 0a0.8 0.8 0 1 0 -1.6 0',
				fill: true,
				opacity: 1,
			},
		],
	},
	bolt: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'm13.25 2.75-7.5 11h5.5l-.5 7.5 7.5-11h-5.5z',
				fill: true,
				opacity: 1,
			},
		],
	},
	microphone: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M12 3.25h0a3.25 3.25 0 0 1 3.25 3.25v4a3.25 3.25 0 0 1 -3.25 3.25h0a3.25 3.25 0 0 1 -3.25 -3.25v-4a3.25 3.25 0 0 1 3.25 -3.25z',
				fill: false,
				opacity: 1,
			},
			{
				d: 'M5.75 11.5a6.25 6.25 0 0 0 12.5 0M12 17.75v3M9.25 20.75h5.5',
				fill: false,
				opacity: 1,
			},
		],
	},
	voice: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M5.5 10v4M9.75 7.5v9M14.25 5.5v13M18.5 9v6',
				fill: false,
				opacity: 1,
			},
		],
	},
	ellipsis: {
		viewBox: [0, 0, 24, 24],
		flipY: false,
		paths: [
			{
				d: 'M4.65 12a1.35 1.35 0 1 0 2.7 0a1.35 1.35 0 1 0 -2.7 0',
				fill: true,
				opacity: 1,
			},
			{
				d: 'M10.65 12a1.35 1.35 0 1 0 2.7 0a1.35 1.35 0 1 0 -2.7 0',
				fill: true,
				opacity: 1,
			},
			{
				d: 'M16.65 12a1.35 1.35 0 1 0 2.7 0a1.35 1.35 0 1 0 -2.7 0',
				fill: true,
				opacity: 1,
			},
		],
	},
	editorClose: {
		viewBox: [0, 0, 16, 16],
		flipY: false,
		paths: [
			{
				d: 'M13.85 13.1502C14.05 13.3502 14.05 13.6602 13.85 13.8602C13.75 13.9602 13.62 14.0102 13.5 14.0102C13.38 14.0102 13.24 13.9602 13.15 13.8602L8 8.71023L2.85 13.8602C2.75 13.9602 2.62 14.0102 2.5 14.0102C2.38 14.0102 2.24 13.9602 2.15 13.8602C1.95 13.6602 1.95 13.3502 2.15 13.1502L7.3 8.00023L2.15 2.85023C1.95 2.65023 1.95 2.34023 2.15 2.14023C2.35 1.94023 2.66 1.94023 2.86 2.14023L8.01 7.29023L13.16 2.14023C13.36 1.94023 13.67 1.94023 13.87 2.14023C14.07 2.34023 14.07 2.65023 13.87 2.85023L8.72 8.00023L13.87 13.1502H13.85Z',
				fill: true,
				opacity: 1,
			},
		],
	},
	editorEllipsis: {
		viewBox: [0, 0, 16, 16],
		flipY: false,
		paths: [
			{
				d: 'M5 8C5 8.55229 4.55228 9 4 9C3.44772 9 3 8.55229 3 8C3 7.44772 3.44772 7 4 7C4.55228 7 5 7.44772 5 8ZM9 8C9 8.55229 8.55229 9 8 9C7.44772 9 7 8.55229 7 8C7 7.44772 7.44772 7 8 7C8.55229 7 9 7.44772 9 8ZM12 9C12.5523 9 13 8.55229 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55229 11.4477 9 12 9Z',
				fill: true,
				opacity: 1,
			},
		],
	},
	react: {
		viewBox: [180, 200, 650, 600],
		flipY: true,
		paths: [
			{
				d: 'M688 394Q688 391 688 386Q694 325 694 294.5Q694 264 679 244Q664 224 641 222Q618 217 591 228Q571 238 535 262Q512 277 500 284Q469 259 450 247Q434 236 419 231Q391 219 367 223.5Q343 228 328.5 247Q314 266 313.5 297Q313 328 319 397Q281 409 262 422Q237 434 212 459Q192 480 193 504.5Q194 529 216 550Q232 569 259 582Q275 591 309 603Q311 603 315.5 604.5Q320 606 322 606L313 675Q312 697 319 734Q326 760 347.5 771Q369 782 397 775Q422 769 447 753Q465 742 488 722Q492 720 497 713L500 709Q550 747 578 763Q610 784 641 775Q664 770 677.5 750.5Q691 731 694 700V650Q694 640 689 620Q686 607 684 600Q712 591 737.5 578.5Q763 566 774 558Q793 545 804 528.5Q815 512 815 494Q815 476 804 459.5Q793 443 774 430Q762 422 737 409Q719 406 687 394ZM506 397Q511 397 522 398Q537 400 544 400Q557 400 566 413Q597 463 609 491Q612 495 612 501Q612 507 609 509Q594 538 562 587Q558 597 547 597Q494 597 466 600Q441 600 428 578Q416 559 409 547L395 521Q386 508 384.5 502.5Q383 497 384.5 491.5Q386 486 395 472L409 447L421 427Q431 411 435 407Q441 400 449 399Q455 398 474 398ZM325 422Q344 472 353 494V506L325 578Q269 561 238 538Q216 521 216 501.5Q216 482 238 466Q254 449 279 438Q294 431 325 422ZM678 581Q666 553 647 503L646 500Q645 497 647 497Q666 447 678 416Q690 422 715 435Q748 450 762 459Q788 476 788 497Q788 518 763 534Q746 549 708 567Q687 576 678 581ZM344 613Q394 618 422 625Q424 625 426 627L428 628Q446 653 478 691Q453 712 440 722Q418 739 397 747Q371 756 355 746.5Q339 737 334 709Q332 690 335 665Q337 650 343 618ZM656 613Q656 614 657.5 618.5Q659 623 659 625Q666 656 666 673Q668 701 659 722Q655 738 644 745Q633 752 619 750Q594 746 570 730Q555 721 529 697L522 691Q538 669 569 631L578 622L656 612ZM344 388Q343 382 341 371Q335 343 334 330Q332 307 338 287Q342 264 357.5 255Q373 246 397 253Q417 259 438 273Q450 282 473 302L481 309Q463 334 431 372Q425 378 422 378Q386 378 344 388ZM519 309Q532 292 557 274Q580 257 600 250Q650 235 659 284Q663 306 661 332Q660 348 654 380L653 384L633 382Q591 379 572 372Q563 367 555 358Q550 352 542 340Q535 330 531.5 324.5Q528 319 519 309ZM538 628Q531 636 518.5 650Q506 664 500 672L495 665Q476 641 463 628ZM538 372H466Q472 364 484.5 350Q497 336 503 328Q510 339 526 358ZM409 403Q405 410 397 424Q380 452 372 469L353 416Q370 409 409 403ZM628 469L591 403L647 413Q643 433 628 469ZM372 531L409 597L353 588L357 575Q364 546 372 531ZM591 597Q597 584 609.5 565.5Q622 547 628 534Q641 572 647 587Q623 588 591 597Z',
				fill: true,
				opacity: 1,
			},
		],
	},
} as const;

const paths = new Map<string, Path2D>();

export const drawAppIcon = (
	ctx: CanvasRenderingContext2D,
	name: keyof typeof appIcons,
	x: number,
	y: number,
	width: number,
	height: number,
	color: string,
	strokeWidth = 1.5,
) => {
	const icon = appIcons[name];
	const [left, top, viewWidth, viewHeight] = icon.viewBox;
	const scale = Math.min(width / viewWidth, height / viewHeight);
	ctx.save();
	ctx.translate(
		x + (viewWidth === viewHeight ? 0 : (width - viewWidth * scale) / 2),
		y + (viewWidth === viewHeight ? 0 : (height - viewHeight * scale) / 2),
	);
	ctx.scale(
		viewWidth === viewHeight ? width / viewWidth : scale,
		viewWidth === viewHeight ? height / viewHeight : scale,
	);
	ctx.translate(-left, -top);
	if (icon.flipY) {
		ctx.translate(0, 1000);
		ctx.scale(1, -1);
	}

	ctx.strokeStyle = color;
	ctx.fillStyle = color;
	ctx.lineWidth = strokeWidth;
	ctx.lineCap = 'round';
	ctx.lineJoin = 'round';
	const opacity = ctx.globalAlpha;
	for (const instruction of icon.paths) {
		let path = paths.get(instruction.d);
		if (!path) {
			path = new Path2D(instruction.d);
			paths.set(instruction.d, path);
		}

		ctx.globalAlpha = opacity * instruction.opacity;
		if (instruction.fill) {
			ctx.fill(path);
		} else {
			ctx.stroke(path);
		}
	}

	ctx.restore();
};
